module.exports = __webpack_public_path__ + "img/flyer-2.66e45d69.jpeg";